import {
  Admin as RaAdmin,
  CustomRoutes,
  Resource,
  type TranslationMessages,
  resolveBrowserLocale
} from 'react-admin'
import { useMediaQuery } from '@mui/material'
import polyglotI18nProvider from 'ra-i18n-polyglot'
import { Route, useParams } from 'react-router-dom'
import log from 'loglevel'
import React from 'react'
import { Login } from 'ra-auth-cognito'
import { ja } from './translations-ja'
import { DataProvider } from 'components/DataProvider'
import { Dashboard } from 'components/Dashboard'
import { Layout } from 'components/Layout'
import { cognitoAuthProvider } from 'components/Auth'
import { adminTheme, desktopTtheme, otherTheme } from 'components/Theme'
import { type Partner } from '@mzc-watchover/adminapp-appsync'
import { isEmpty, isNil } from 'lodash/fp'
import { AdminDashboard } from 'components/AdminDashboard'
import { userCognitoAuthProvider } from 'components/UserAuth'
import { ParsonalUser } from 'components/ParsonalUser'
import {
  BankAccountCompleteForm,
  BankAccountForm
} from 'components/BankAccount'
import { UserDataProvider } from 'components/UserDataProvider'

log.setLevel(log.levels.DEBUG)

const translations: Record<string, TranslationMessages> = { ja }
const i18nProvider = polyglotI18nProvider(
  (locale) => translations[locale] as TranslationMessages,
  resolveBrowserLocale(),
  [{ locale: 'ja', name: '日本語' }]
  // { allowMissing: true }
)
export const Admin: React.FC<{ user?: boolean }> = ({ user }) => {
  const { partnerId } = useParams()
  const isDesktop = useMediaQuery('(min-width: 900px)')
  const [partner, setPartner] = React.useState<Partial<Partner> | undefined>(
    undefined
  )
  const dataProvider = DataProvider(
    !isNil(partner) ? (partner.id as string) : undefined
  )
  const userDataProvider = UserDataProvider(partnerId)
  const userCognitoProvider = !isEmpty(partnerId)
    ? userCognitoAuthProvider(partnerId)
    : undefined
  const getPartner = (): Partial<Partner> | undefined => partner
  // if (!isNil(user) && user &&
  //   window.location.pathname !== `/users/${partnerId}` &&
  //   window.location.pathname !== '/login') {
  //   console.log('redirect!')
  //   // @ts-expect-error ts(2322)
  //   window.location = `/users/${partnerId}`
  // }
  return !isNil(partnerId) &&
    !isNil(user) &&
    user &&
    !isNil(userCognitoProvider) ? (
    <RaAdmin
      basename={`/users/${partnerId}`}
      dataProvider={userDataProvider}
      i18nProvider={i18nProvider}
      authProvider={userCognitoProvider}
      loginPage={Login}
      requireAuth
      layout={Layout}
      lightTheme={isDesktop ? desktopTtheme : otherTheme}
      darkTheme={adminTheme}>
      <CustomRoutes>
        <Route path="/" element={<ParsonalUser />} />
        <Route path="/bankaccount/:id" element={<BankAccountForm />} />
        <Route
          path="/gmo/bankaccount/complete"
          element={<BankAccountCompleteForm />}
        />
      </CustomRoutes>
    </RaAdmin>
  ) : isNil(user) || !user ? (
    <RaAdmin
      dataProvider={dataProvider}
      i18nProvider={i18nProvider}
      authProvider={cognitoAuthProvider}
      loginPage={Login}
      requireAuth
      layout={Layout}
      lightTheme={isDesktop ? desktopTtheme : otherTheme}
      darkTheme={adminTheme}>
      <Resource name="organizations" />
      <CustomRoutes>
        <Route
          path="/"
          element={
            <Dashboard setPartner={setPartner} getPartner={getPartner} />
          }
        />
        <Route
          path="/external/:userId"
          element={
            <Dashboard setPartner={setPartner} getPartner={getPartner} />
          }
        />
        <Route
          path="/:id/changeContact"
          element={
            <Dashboard
              setPartner={setPartner}
              getPartner={getPartner}
              target="changeContact"
            />
          }
        />
        <Route
          path="/:id/editOrganizations"
          element={
            <Dashboard
              setPartner={setPartner}
              getPartner={getPartner}
              target="editOrganizations"
            />
          }
        />
        <Route
          path="/:id/editAccounts"
          element={
            <Dashboard
              setPartner={setPartner}
              getPartner={getPartner}
              target="editAccounts"
            />
          }
        />
        <Route path="/:cognito" element={<Dashboard target="cognito" />} />
        <Route path="/:cognito/announces" element={<AdminDashboard />} />
      </CustomRoutes>
    </RaAdmin>
  ) : (
    <></>
  )
}
